module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "introduction"
    }
  }, [_c('h1', [_vm._v("Introduction")]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "why-i-like-extended-multi-day-paddling-trips"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "left",
      "font-family": "Garamond",
      "font-weight": "bold",
      "letter-spacing": "1px",
      "padding-bottom": "5px",
      "font-size": "17px"
    }
  }, [_vm._v("Why I Like Extended Multi-Day Paddling Trips")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Why do I favor extended paddling trips over day trips? First, I don’t enjoy day trips the way I used to because it takes almost as much preparation and clean-up work to paddle for three or four hours as it does to go away for several days. Multi-day trips allow me to spend many more hours in the outdoors, often in wilderness areas where the trappings of our modern, climate-controlled, high tech lives mean little, where we must accommodate the natural rhythms of dawn and dusk, hot and cold, calm and wind, sun and rain, on nature’s schedule, not our own.")]), _vm._v(" "), _c('p', [_vm._v("Second, self-planned and self-supported multi-day trips require investigation and preparation. The planning becomes part of the adventure. These trips are exciting, requiring the paddler to cope with conditions as they are and make adjustments. In the end, there is a lot of satisfaction in successfully completing self-planned trips. Completing such a trip brings a level of satisfaction and pride I don’t get when I just show up for an adventure that someone else has planned and arranged.")]), _vm._v(" "), _c('p', [_vm._v("However, as I’ve gotten older, and perhaps lazier, I’ve gravitated toward, supported, group trips. I have done many of these over the years from Georgian Bay to the Hudson and Potomac Rivers, Costa Rica, Mexico, and even the Colorado."), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn1",
      "id": "fnref1"
    }
  }, [_vm._v("1")]), _vm._v(" But since moving to Florida, I have paddled many supported trips with an organization called Paddle Florida."), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn2",
      "id": "fnref2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', [_vm._v("Paddle Florida sponsors one trip in each of the five water districts in the state every year. As a new resident, I have seen parts of Florida that many old-timers don’t even know about. A Paddle Florida trip includes all of your meals, preplanning for campsites, evening entertainment, and transportation to your car at the end of the event; it does this at about half the cost of a similar trip with a commercial outfitter. Two of the stories in this book are about Paddle Florida adventures.")]), _vm._v(" "), _c('p', [_vm._v("Finally, and this is by no means least important, through kayaking I have met and become friends with other paddlers from around the state, the country, and the world. This was my experience on the several Great Hudson River Paddles I was on years ago, where I made friends I continue to paddle with to this day. This has been my experience on Paddle Florida trips, too. After many of these adventures, I feel that this, more than anything else, keeps me coming back.")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnotes"
  }, [_c('hr'), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    attrs: {
      "id": "fn1"
    }
  }, [_c('sup', [_vm._v("1 ")]), _vm._v("Several of these trips are detailed in my first book, "), _c('em', [_vm._v("The Idling Bulldozer and Other Paddling Adventures")]), _vm._v("."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref1"
    }
  }, [_vm._v("↩︎")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn2"
    }
  }, [_c('sup', [_vm._v("2 ")]), _vm._v("Go to www.paddleflorida.org for more information"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref2"
    }
  }, [_vm._v("↩︎")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a49197e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 78
// module chunks = 0